/**
 * Product menu
 */

(function () {

  var product_menu_wrapper = document.querySelector('.js-product-navigation');
  var product_menu_toggle = document.querySelector('.js-product-navigation-toggle');
  var product_menu_overlay = document.querySelector('.js-product-navigation-overlay');

  if (product_menu_wrapper && product_menu_toggle && product_menu_overlay) {

    // overlay => close menu on click
    product_menu_overlay.addEventListener('click', function () {
      product_menu_toggle.click();
    });

    // toggle => open/close menu
    product_menu_toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (e.currentTarget.getAttribute('aria-expanded') == 'true') {
        e.currentTarget.setAttribute('aria-expanded', 'false');
        product_menu_wrapper.classList.remove('is-active-product-menu');
      } else {
        e.currentTarget.setAttribute('aria-expanded', 'true');
        product_menu_wrapper.classList.add('is-active-product-menu');
      }
    });

  }

}());
